export const PRIVACY_POLICY_META = {
  title: "Privacy Policy",
  eyebrow: "Trust desk",
  updatedAt: "September 1, 2026",
  readMinutes: 6,
  summary: "How BetBond handles data for P2P matching, escrow, security, retention, and your choices.",
  intro:
    "How we handle your data on BetBond’s peer-to-peer platform. By using the platform, you agree to this policy.",
  platformNote:
    "BetBond provides technology so users can form peer-to-peer sports offers, match with counterparties, and settle through escrow. We charge service fees on completed P2P activity—we do not sell personal data or take the other side of user agreements.",
};

export const PRIVACY_PROMISES = [
  {
    id: "no-sell",
    label: "No data selling",
    detail: "Personal information is never sold to advertisers or brokers.",
  },
  {
    id: "escrow",
    label: "Escrow-first",
    detail: "Payment records exist to run settlements—not to profile you for ads.",
  },
  {
    id: "adults",
    label: "18+ platform",
    detail: "Not designed for minors; we act if under-age use is detected.",
  },
];

export const PRIVACY_SECTIONS = [
  {
    id: "collect",
    title: "Information we collect",
    index: "01",
    blocks: [
      {
        subheader: "You provide",
        bullets: [
          "Account: username, email, password (stored securely), display name, date of birth where required",
          "Profile details you choose (photo, bio, location, favorites)",
          "Identity verification materials if we request them",
          "Content you send or post—chat messages and P2P offer details",
        ],
      },
      {
        subheader: "Payments & activity",
        bullets: [
          "Payment details through third-party processors—we do not store full card numbers",
          "Records of funding, withdrawals, P2P escrow, settlements, service fees, and in-app balances",
        ],
      },
      {
        subheader: "Automatically",
        bullets: [
          "Usage, device, and log data—including IP address, approximate location from IP, and crash reports",
          "Session timing data (such as session start, last activity, and break status) to apply mandatory session breaks",
        ],
      },
    ],
  },
  {
    id: "use",
    title: "How we use information",
    index: "02",
    bullets: [
      "Run P2P matching: offers, invites, escrow locks, settlements, and the 7% service fee",
      "Use third-party sports data where needed to verify fixture outcomes for agreed P2P conditions",
      "Check eligibility, verify accounts, and reduce fraud or abuse",
      "Support you, send operational messages (including P2P and wallet alerts), improve the product, and meet legal obligations",
      "Apply session breaks and support balanced platform use",
    ],
  },
  {
    id: "share",
    title: "How we share information",
    index: "03",
    lead: "We do not sell your personal information. We share it only where needed:",
    bullets: [
      "With other users: information you make public on the platform",
      "With processors and vendors: payments, hosting, verification, analytics, outcome data, support tools",
      "For legal reasons: to comply with law, respond to lawful requests, or protect rights and safety",
    ],
  },
  {
    id: "security",
    title: "Security",
    index: "04",
    bullets: [
      "Encryption in transit, secure password handling, access controls, and monitoring",
      "You should use a strong password and protect your login",
    ],
    footnote:
      "No method of storage or transmission is perfectly secure; we cannot guarantee absolute security.",
  },
  {
    id: "choices",
    title: "Your choices & retention",
    index: "05",
    blocks: [
      {
        subheader: "Deleting your account",
        bullets: [
          "In the BetBond app: Profile → Settings → Delete account",
          "Deletion is permanent—not the same as logging out or temporarily deactivating an account",
          "You confirm with your password in the app. If no activity is blocking deletion, the account is deleted immediately",
          "If activity is blocking deletion, you can join the deletion queue and cancel the queue before deletion completes",
          "We may block deletion until wallet balances are cleared and any open P2P offers, invites, or escrow settlements that affect other users are finished",
          "When deletion completes, we remove or anonymize profile and user-authored content; some transaction and compliance records may be kept as described below",
        ],
      },
      {
        subheader: "Rights",
        bullets: [
          "Request access, correction, or deletion where applicable—some records must be kept for law or disputes",
          "Opt out of promotional messages where offered; operational emails may still be required",
        ],
      },
      {
        subheader: "Retention summary",
        bullets: [
          "Data needed for an active account while you use the service",
          "Transaction records often kept longer for compliance",
          "We may remove or anonymize data when no longer needed",
        ],
      },
    ],
  },
  {
    id: "more",
    title: "Children, transfers, updates, contact",
    index: "06",
    blocks: [
      {
        subheader: "Children",
        prose:
          "BetBond is not for users under 18. If we learn a minor's data was collected, we will take steps to delete it and restrict the account.",
      },
      {
        subheader: "International processing",
        prose:
          "We may process or store data in Rwanda and other countries where our vendors operate, using appropriate safeguards where required.",
      },
      {
        subheader: "Changes",
        prose:
          "We may update this policy and will change the last updated date. For important changes, we may notify you in the app or by email.",
      },
      {
        subheader: "Contact",
        prose: "Questions about privacy: betbondofficial@gmail.com",
        email: "betbondofficial@gmail.com",
      },
    ],
  },
];
